import React, { useState, useEffect } from "react";

const Counter = ({ end, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const duration = 2000;
    const increment = end / (duration / 16);
    let current = 0;

    const timer = setInterval(() => {
      current += increment;
      if (current >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(current));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [end]);

  return (
    <div className="text-center p-6 bg-emerald-50 rounded-lg">
      <div className="text-5xl font-bold text-emerald-800 mb-2">
        {count}{label}
      </div>
    </div>
  );
};

export default function About() {
  return (
    <div className="w-full bg-white">
      {/* HEADER SECTION */}
     

      <div className="w-full  py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h1 className="text-5xl font-bold text-black mb-4 tracking-wide">
            THE GUIDE
          </h1>
          <p className="text-black text-xl mb-2">
            Published by Malik Deenar Islamic Academy
          </p>
          <p className="text-black  max-w-2xl mx-auto italic">
            A bi-monthly academic magazine fostering intellectual growth, critical thinking, and scholarly engagement
          </p>
        </div>
      </div>
       {/* STATISTICS / IMPACT */}
        <section className="space-y-6 bg-gray-50 -mx-6 px-6 py-12 md:mx-0 md:rounded-lg">
          <h2 className="text-3xl font-semibold text-emerald-900 text-center">Our Impact</h2>
          
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="text-5xl font-bold text-emerald-800 mb-2">
                <Counter end={700} label="+" />
              </div>
              <p className="text-gray-700 font-medium text-lg">Subscriptions</p>
              <p className="text-gray-600 text-sm mt-1">A growing community of engaged readers</p>
            </div>

            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="text-5xl font-bold text-emerald-800 mb-2">
                <Counter end={65} label="+" />
              </div>
              <p className="text-gray-700 font-medium text-lg">Published Articles</p>
              <p className="text-gray-600 text-sm mt-1">Scholarly writings across disciplines</p>
            </div>

            <div className="text-center p-6 bg-white rounded-lg shadow-sm">
              <div className="text-5xl font-bold text-emerald-800 mb-2">
                <Counter end={70} label="+" />
              </div>
              <p className="text-gray-700 font-medium text-lg">MySpaces</p>
              <p className="text-gray-600 text-sm mt-1">Intellectual and creative sections</p>
            </div>
          </div>

          <p className="text-gray-600 text-center italic max-w-2xl mx-auto pt-4">
            These milestones reflect the trust of our readers and our commitment to knowledge-driven engagement.
          </p>
        </section>

      {/* MAIN CONTENT */}
      <div className="max-w-5xl mx-auto px-6 py-16 space-y-16">

        {/* ABOUT THE MAGAZINE */}
        <section className="space-y-4">
          <h2 className="text-3xl font-semibold text-emerald-900">About the Magazine</h2>
          <p className="text-gray-700 leading-relaxed">
            The Guide is a bi-monthly academic magazine published by Malik Deenar Islamic Academy. The magazine is dedicated to fostering intellectual growth, critical thinking, and scholarly engagement among readers. Rooted in a strong academic and ethical tradition, The Guide serves as a platform for meaningful discourse, thoughtful analysis, and knowledge-based exploration.
          </p>
          <p className="text-gray-700 leading-relaxed">
            The Guide explores a wide range of academic exposures, including contemporary issues, social realities, intellectual traditions, and current affairs, all examined through a scholarly and analytical lens. Each issue aims to bridge classical knowledge with modern perspectives, encouraging readers to engage thoughtfully with ideas and realities shaping the world today.
          </p>
          <p className="text-gray-700 leading-relaxed">
            Committed to academic integrity and editorial excellence, The Guide publishes well-researched articles, insightful essays, and intellectually stimulating content. The magazine aspires to serve students, scholars, and readers who seek depth, clarity, and relevance in academic writing.
          </p>
        </section>

        {/* JOURNEY & EVOLUTION */}
        <section className="space-y-4">
          <h2 className="text-3xl font-semibold text-emerald-900">Journey & Evolution</h2>
          <p className="text-gray-700 leading-relaxed">
            In its early stages, The Guide was published as a supplementary publication alongside academic activities. Over time, with increasing readership and demand for in-depth intellectual content, it evolved into a full-fledged independent magazine.
          </p>
          <p className="text-gray-700 leading-relaxed">
            This transformation reflects the trust of its readers and the continuous efforts of its editorial team. What began as a modest academic supplement has grown into a respected platform for scholarly discourse, serving a community that values rigorous analysis and thoughtful engagement with ideas.
          </p>
        </section>

        {/* VISION & COMMITMENT */}
        <section className="space-y-4">
          <h2 className="text-3xl font-semibold text-emerald-900">Vision & Commitment</h2>
          <p className="text-gray-700 leading-relaxed">
            Our vision is to cultivate a community of intellectually curious readers who engage critically with contemporary issues while remaining grounded in timeless ethical and scholarly principles. We believe that knowledge should not exist in isolation but should actively contribute to understanding and improving the world around us.
          </p>
          <p className="text-gray-700 leading-relaxed">
            The Guide remains committed to maintaining the highest standards of academic integrity and editorial excellence. We strive to present diverse perspectives, encourage critical dialogue, and provide our readers with content that is both intellectually rigorous and practically relevant.
          </p>
        </section>

        

        {/* WHAT WE PUBLISH */}
        <section className="space-y-4">
          <h2 className="text-3xl font-semibold text-emerald-900">What We Publish</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2 leading-relaxed">
            <li>Well-researched academic articles on contemporary issues</li>
            <li>Thoughtful essays bridging classical and modern knowledge</li>
            <li>Analytical writings on social realities and current affairs</li>
            <li>Intellectual explorations of cultural and ethical traditions</li>
            <li>Scholarly content that encourages critical thinking</li>
          </ul>
        </section>

        {/* CONTACT */}
        <section className="space-y-4 border-t pt-10">
          <h2 className="text-3xl font-semibold text-emerald-900">Connect With Us</h2>
          <p className="text-gray-700 leading-relaxed">
            Interested in contributing, subscribing, or learning more about The Guide?  
            We welcome inquiries from students, scholars, and thoughtful readers.
          </p>
          <p className="text-gray-800 font-medium">📧 Published by Malik Deenar Islamic Academy</p>
        </section>

      </div>
    </div>
  );
}